import { render, staticRenderFns } from "./SpaceResearchTab.vue?vue&type=template&id=e1069bbc&scoped=true"
import script from "./SpaceResearchTab.vue?vue&type=script&lang=js"
export * from "./SpaceResearchTab.vue?vue&type=script&lang=js"
import style0 from "./SpaceResearchTab.vue?vue&type=style&index=0&id=e1069bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1069bbc",
  null
  
)

export default component.exports